import { SpinnerMask } from '@atlassian/amkt-common';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import CommonPropTypes from '../../app/constants/PropTypes';
import ServerError from './ServerError';

export default class ServerErrorSpinnerMask extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired,
    homeLink: CommonPropTypes.link.isRequired,
    history: CommonPropTypes.history,
    isError: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    statusCode: PropTypes.number,
  };

  static defaultProps = {
    statusCode: 500,
  };

  render() {
    return (
      // @ts-expect-error [MC-2850] - TS2339 - Property 'loading' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. | TS2322 - Type '{ children: any; active: any; optimisticLoadTime: number; }' is not assignable to type 'IntrinsicAttributes & SpinnerMaskProps'.
      <SpinnerMask active={this.props.loading} optimisticLoadTime={200}>
        {/* @ts-expect-error [MC-2850] - TS2339 - Property 'loading' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. */}
        {!this.props.loading ? (
          // @ts-expect-error [MC-2850] - TS2339 - Property 'isError' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
          this.props.isError ? (
            <ServerError
              // @ts-expect-error [MC-2850] - TS2322 - Type '{ history: any; homeLink: any; statusCode: any; }' is not assignable to type 'IntrinsicAttributes & ServerErrorProps'. | TS2339 - Property 'history' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
              history={this.props.history}
              // @ts-expect-error [MC-2850] - TS2339 - Property 'homeLink' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
              homeLink={this.props.homeLink}
              // @ts-expect-error [MC-2850] - TS2339 - Property 'statusCode' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
              statusCode={this.props.statusCode}
            />
          ) : (
            // @ts-expect-error [MC-2850] - TS2723 - Cannot invoke an object which is possibly 'null' or 'undefined'. | TS2349 - This expression is not callable.
            this.props.children()
          )
        ) : null}
      </SpinnerMask>
    );
  }
}
